const WISHLIST_KEY = 'reevys:wishlist:v1';

function readWishlist() {
  const value = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
  return Array.isArray(value) ? value : [];
}

class ReevysCardSave extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.product = JSON.parse(this.querySelector('script').textContent);
    this.button.addEventListener('click', this.toggle);
    window.addEventListener('reevys:wishlist:change', this.sync);
    window.addEventListener('storage', this.sync);
    this.sync();
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.toggle);
    window.removeEventListener('reevys:wishlist:change', this.sync);
    window.removeEventListener('storage', this.sync);
  }

  sync = () => {
    let items = [];
    try { items = readWishlist(); } catch { /* Private browsing may block storage. */ }
    const saved = items.some(item => String(item.id) === String(this.product.id));
    const label = saved ? this.button.dataset.removeLabel : this.button.dataset.saveLabel;
    this.button.setAttribute('aria-pressed', String(saved));
    this.button.setAttribute('aria-label', label);
    this.button.title = label;
  };

  toggle = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const status = this.querySelector('[role="status"]');
    try {
      const items = readWishlist();
      const index = items.findIndex(item => String(item.id) === String(this.product.id));
      if (index >= 0) items.splice(index, 1);
      else items.unshift({ ...this.product, addedAt: Date.now() });
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
      status.textContent = '';
      window.dispatchEvent(new CustomEvent('reevys:wishlist:change', { detail: { count: items.length, items } }));
    } catch {
      status.textContent = status.dataset.error;
    }
  };
}

class ReevysCardColors extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.button?.addEventListener('click', this.expand);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.expand);
  }

  expand = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.setAttribute('expanded', '');
    this.button.setAttribute('aria-expanded', 'true');
    this.querySelector('.reevys-card-color--extra')?.focus({ preventScroll: true });
    this.button.hidden = true;
  };
}

function openFacetTarget(target) {
  const drawer = document.getElementById('filters-drawer');
  if (!drawer) return;

  const focusTarget = () => {
    if (!drawer.querySelector('dialog[open]')) return;
    const input = [...drawer.querySelectorAll('input[name]')].find((node) => node.name === target);
    const selectedDetails = input?.closest('details');
    const panels = drawer.querySelectorAll('.facets__filters-wrapper details');
    for (const details of panels) {
      const shouldOpen = target === 'all' || details === selectedDetails;
      if (details.open !== shouldOpen) details.querySelector('summary')?.click();
    }
    const selected = target === 'sort'
      ? drawer.querySelector('select[name="sort_by"]:not([disabled])')
      : selectedDetails?.querySelector('summary');
    const scroller = drawer.querySelector('.facets-drawer__filters');
    if (scroller) scroller.scrollTop = 0;
    selected?.focus({ preventScroll: true });
  };

  // Native drawer opening finishes before positioning its requested section.
  requestAnimationFrame(() => requestAnimationFrame(focusTarget));
}

document.addEventListener('click', (event) => {
  const trigger = event.target?.closest?.('[data-reevys-filter-target]');
  if (!trigger) return;
  openFacetTarget(trigger.dataset.reevysFilterTarget);
});

if (!customElements.get('reevys-card-save')) customElements.define('reevys-card-save', ReevysCardSave);
if (!customElements.get('reevys-card-colors')) customElements.define('reevys-card-colors', ReevysCardColors);
